import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';

type ChangeBlockLengthHandler = (value: number) => void;
type ChangeBlockPerYearHandler = (value?: number) => void;

type ContractPartTimeVariableBlockProps = {
    onChangeBlockLength: ChangeBlockLengthHandler;
    onChangeBlockPerYear: ChangeBlockPerYearHandler;
    blockLength?: number;
    blockPerYear?: number;
    className?: string;
    disabled?: boolean;
};

export class ContractPartTimeVariableBlock extends React.PureComponent<ContractPartTimeVariableBlockProps,{}>{
    private _store: ContractPartTimeVariableBlockStore;

    constructor(props: ContractPartTimeVariableBlockProps) {
        super(props);
        this._store = new ContractPartTimeVariableBlockStore(props);
    }
    
    render(){
        return(
            <>
                <Dropdown
                    label="Block Length"
                    options={this._store.variableBlockLengthOptions}
                    onChange={this._store.onChangeBlockLength}
                    required
                    selectedKey={this.props.blockLength}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Blocks PerYear"
                    options={this._store.variableBlockPerYearOptions(this.props.blockLength)}
                    onChange={this._store.onChangeBlockPerYear}
                    required
                    selectedKey={this.props.blockPerYear || ''}
                    className={this.props.className}
                    disabled={this.props.disabled || !this.props.blockLength}
                />
            </>
        );
    }
}

class ContractPartTimeVariableBlockStore {
    private readonly _onChangeBlockLengthFunction: ChangeBlockLengthHandler;
    private readonly _onChangeBlockPerYearFunction: ChangeBlockPerYearHandler;

    constructor(props: ContractPartTimeVariableBlockProps) {
        this._onChangeBlockLengthFunction = props.onChangeBlockLength;
        this._onChangeBlockPerYearFunction = props.onChangeBlockPerYear;
    }

    onChangeBlockLength = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockLengthFunction(option.key as number);
            this._onChangeBlockPerYearFunction(undefined);
        }
    };

    onChangeBlockPerYear = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockPerYearFunction(option.key as number);
        }
    };

    get variableBlockLengthOptions() {
        return [
            {key: 7, text: '7'},
            {key: 14, text: '14'},
            {key: 28, text: '28'},
        ];
    }

    variableBlockPerYearOptions(blockLength: number | undefined) {
        if (blockLength === 7){
            return [
                {key: 4, text: '4'},
                {key: 6, text: '6'},
                {key: 12, text: '12'},
            ];
        }
        if (blockLength === 14){
            return [
                {key: 2, text: '2'},
                {key: 3, text: '3'},
                {key: 4, text: '4'},
            ];
        }
        if (blockLength === 28){
            return [
                {key: 1, text: '1'},
                {key: 2, text: '2'},
                {key: 3, text: '3'},
            ];
        }
        return [];
    }
}